export const pushToDataLayer = (eventName, payload = null) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    dashboardVersion: 'oldDashboard',
    ...payload,
  });
};
